export const listItemsTableColumnsMinWidth = {
  platform: 35,
  name: 270,
  objective: 150,
  impressions: 90,
  activeViewImpressions: 118,
  reach: 118,
  clicks: 95,
  engagements: 95,
  videoViews: 118,
  conversions: 120,
  leads: 118,
  roas: 40,
  spend: 110,
  status: 90,
  dropdown: 24
}

export const listItemsTableColumnsMaxWidth = {
  checkbox: 45,
  platform: 35,
  name: 300,
  objective: 180,
  impressions: 120,
  activeViewImpressions: 120,
  reach: 125,
  clicks: 120,
  engagements: 120,
  videoViews: 120,
  conversions: 120,
  leads: 120,
  roas: 100,
  spend: 110,
  status: 100,
  dropdown: 24
}
